import { Box, Paper, Typography } from '@mui/material';
import { useSearchParams } from 'react-router';
import { LoginButton } from '../shared/components/auth/LoginButton';
import styles from './login.module.css';
import { useLanguageContext } from '@mbd/ui-components';
import { Link } from '@airbus/components-react';

export function LoginPage() {
  const [searchParams] = useSearchParams();
  const { t } = useLanguageContext();

  const message = searchParams.get('message');
  const state = searchParams.get('state');

  return (
    <div className={styles.container}>
      <Typography variant='h4' style={{ fontWeight: 600 }}>
        {t('app_name')}
      </Typography>

      {message && (
        <Typography variant='h6' style={{ fontWeight: 300 }}>
          {message}
        </Typography>
      )}

      <Paper className={styles.paper}>
        <Typography variant='h6' gutterBottom>
          Login
        </Typography>
        <Typography variant='body2'>{t('enterprise')}</Typography>
        <LoginButton state={state}>Sign in</LoginButton>
      </Paper>

      <Box className={styles.links}>
        <Link href='https://sites.google.com/airbus.com/mbdcp/support' target='_blank'>
          {t('support')}
        </Link>
      </Box>
    </div>
  );
}
